<script lang="ts">
    export let direction = "right";
    export let isPaused = false;
    export let rootElement;
    let flipsvg = false;

    if (direction == "left") {
      flipsvg = true;
    }
</script>

<style lang="scss">
  * {
    .shapes > * {
    opacity: 0;
    animation-duration: 5s;
    animation-iteration-count: infinite;
    animation-timing-function: steps(1);
  }
  @keyframes lunge-1 {
    0%,
    25% {
      opacity: 1;
    }
    25%,
    50% {
      opacity: 0;
    }
    50%,
    75% {
      opacity: 1;
    }
    75%,
    100% {
      opacity: 0;
    }
  }
  #lunge-1 {
    animation-name: lunge-1;
  }
  @keyframes lunge-2 {
    0%,
    25% {
      opacity: 0;
    }
    25%,
    50% {
      opacity: 1;
    }
    50%,
    100% {
      opacity: 0;
    }
  }
  #lunge-2 {
    animation-name: lunge-2;
  }
  @keyframes lunge-3 {
    0%,
    75% {
      opacity: 0;
    }
    75%,
    100% {
      opacity: 1;
    }
  }
  #lunge-3 {
    animation-name: lunge-3;
  }

  .paused .shapes > * {
    filter: grayscale(100%);
      opacity: 0.8;
      animation-play-state: paused;
    }
  
  .flip .shapes > *{
    transform-origin: center center;
    transform: scaleX(-1); }

}
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 483.3 693.4" height="100%" width="100%">>
<g class:paused={isPaused} class:flip={flipsvg}>
  <g class="shapes" bind:this={rootElement}>
    <g id="lunge-1">
      <path
        fill="var(--pants)"
        d="m433 320 8-1c1 6 1 12 4 16a29 29 0 0 1 5 28c-3 9 5 13 5 21 0 1 3 2 4 0 3-4 3 2 5 1-3 12-1 25-2 37l-2 10c-2 12-2 12-14 13l-55 3c-13-1-13-1-13-13 0-25-2-50-11-74-4-11-4-23-3-35 6 6 13 5 20 3 10-3 21-5 31-6l8 1c5 1 7 0 10-4Z"
      />
      <path fill="var(--shirt)" d="M452 288Z" />
      <path fill="var(--hair)" d="M392 76Z" />
      <path
        fill="var(--hair)"
        d="M473 643c3-2 5-4 4-8-1-3-4-5-7-5-4 0-8-2-12-4a188 188 0 0 1-27-16c-4-3-7-5-7-10 0-2 0-6-5-3a3 3 0 0 1-1 0c-3 0-2 3-3 4 2 5 0 8-5 10l-1 8c-4 3-9 4-12 10-4 8-13 5-19-5l-3-6c-2 0-3-1-3-3s1-3 2-3a1 1 0 0 1 2-1c-1-1-1-3-4-2a4 4 0 0 0-3 4c1 6-1 11 1 17v2a1 1 0 0 1 0 1 1 1 0 0 0 0-1l1 9a5 5 0 0 0 1-2 5 5 0 0 1-1 2c1 4-1 8 1 12a3 3 0 0 0 2 3c6 3 12 4 18 5a2 2 0 0 0 3 1h4l8 2 2 1c4 3 7 5 12 6l4 1c6 2 12 2 19 1 8-2 17-3 24-9 6-3 8-10 4-14-3-4-2-5 1-7Zm-100-7a7 7 0 0 0-1 0 7 7 0 0 1 1 0Zm0 3a2 2 0 0 0 0-1 2 2 0 0 1 0 1Z"
      />
      <path fill="var(--shirt)" d="M466 317ZM468 318Z" />
      <path
        fill="var(--pants)"
        d="M433 320c-3 4-5 5-10 3h-8c6-2 12-4 18-3Z"
      />
      <path
        fill="var(--hair)"
        d="M459 4c-3-4-7-2-11-2-3 0-7 1-10-2h-28c-3 4-8 3-12 4-15 3-23 13-22 28s4 30 8 44a4 4 0 0 0 2 5c3 0 5-1 6-5 8-6 2-13 1-20-1-5 0-9 4-12 6-2 10 1 12 7 2 8 6 9 12 3a16 16 0 0 0 1-3l3-4c0-6 2-10 8-13 3-1 4-5 3-8-1-8 2-11 9-8l8 3 1-2a26 26 0 0 0 3-3c2-4 4-8 2-12Z"
      />
      <path
        fill="var(--hair)"
        d="M375 618c-2 0-3-1-3-3s1-3 3-3v2h-1a7 7 0 0 0 1 1v2Z"
      />
      <path fill="var(--pants)" d="M375 616v-1l1 1a9 9 0 0 0-1 0Z" />
      <path
        fill="var(--pants)"
        d="M375 615a7 7 0 0 1-1-1s0 0 1-1a1 1 0 0 1 0 2Z"
      />
      <path
        d="M465 296c-6-35-7-70-5-106 0-9-1-19-5-27-2-9-6-17-11-25-1-4-3-7-6-10a38 38 0 0 0-8-13c0-2-1-3-3-4-3 1-2 3-2 5-1 6-3 8-8 5l-9-2c-4-6-12-8-19-10l-8-12c-8 5-9 15-13 22s-5 15-11 21v27a178 178 0 0 1 12 86c-1 10-1 21-4 31-6 14-3 28-1 42 6 6 13 5 20 3 10-3 21-5 31-6 6-2 12-4 18-3l8-1a17 17 0 0 0-6-11c-9-8-15-19-24-27-7-5-11-15-13-24-1-3-4-6-3-10-1-1-2 2-2 0v-17l1-1c-4-2-2-6-3-10-3-7-5-15-5-23-4-2-1-6-2-9a44 44 0 0 1 0-12c12 3 23 1 34 1 3 1 6-1 7 3a7 7 0 0 0 1 0 7 7 0 0 1-1 0v33c0 5 0 10 3 14l7 18c2 3 4 7 3 11 4 0 2 5 4 6l2 2v6c4 3 5 8 5 13 4 1 3 3 3 6 2 0 3 1 2 2l1 3c4 3 4 7 5 11s2 7 6 8c1-5 0-11-1-16Zm-36-109-1-1v-1l2 1-1 1Zm9-10a3 3 0 0 0-1-3 3 3 0 0 1 1 3Zm-1 19a93 93 0 0 1 2 13 93 93 0 0 0-2-13Zm6 61a19 19 0 0 0 1-3 19 19 0 0 1-1 3Z"
        fill="var(--shirt)"
      />
      <path d="m428 185 2 1-1 1-1-1Z" fill="var(--shirt)" />
      <path
        fill="var(--flesh)"
        d="m468 318-2-1v-5c-4-1-5-4-6-8s-1-9-5-11l-1-3a2 2 0 0 1-2-1 2 2 0 0 0 2 1c1-1 0-2-2-2 0-3 1-5-3-6v6a3 3 0 0 0-2 1 3 3 0 0 1 2-1v-6c0-5-1-10-5-13v-6l-2-2c-2-1 0-6-4-6 1-4-1-8-3-11l-7-18c-3-4-3-9-3-14v-33c-1-4-4-2-7-3-11 0-22 2-34-1a44 44 0 0 0 0 12c1 3-2 7 2 9 0 8 2 16 5 23 1 4-1 8 3 10l-1 1v17c0 2 1-1 2 0-1 4 2 7 3 10 2 9 6 19 13 24 9 8 15 19 24 27a17 17 0 0 1 6 11c1 6 1 12 5 16a29 29 0 0 1 4 28c-3 9 6 13 5 21 0 1 3 2 4 0 3-4 3 2 5 1 7 1 6-6 9-8 1 2 0 5 3 5s3-3 3-5l4-13c1-10 1-20-4-28l-11-18ZM381 493a55 55 0 0 0-4 8c-4 9-8 17-7 26l4 49c1 12 3 23 1 35a1 1 0 0 0-1 1l1 1a1 1 0 0 1 0 2l1 1a9 9 0 0 0-1 0v2l3 6c6 10 15 13 19 5 3-6 7-7 12-10l1-8c5-2 7-5 5-10 1-1 0-4 3-4l-1-8v-4c2-14-1-28-1-42l1-5 1-7c1-10 1-22 6-30 12-17 17-37 22-56-18 1-37 4-55 3 2 16-1 31-10 45Zm-3 131 1-2-1 2Zm36-29a8 8 0 0 0 0 1 5 5 0 0 0 0 1 5 5 0 0 1 0-1 8 8 0 0 1 0-1 11 11 0 0 1 1-2 11 11 0 0 0-1 2Zm6-91-2-4 2 4Zm-2-4a5 5 0 0 0-3-1 5 5 0 0 1 3 1ZM375 615ZM386 81c-3 5-1 11-5 16l8 12c7 2 15 4 19 10l9 2c5 3 7 1 8-5 0-2-1-4 2-5-1-10 5-17 15-16 4 1 11 1 12-3 1-8 7-13 6-21a4 4 0 0 1 1-4c5-4 3-7 1-11-2-3-6-5-6-9 3-9-2-17-3-26-3-1-5-3-8-3-8-3-10 0-9 8 1 3 0 7-3 8-6 3-8 7-8 13l-3 4a16 16 0 0 1-2 3c-5 6-9 5-11-3-2-6-6-9-12-7-4 3-5 7-4 12 1 7 7 14-1 20-1 4-3 5-6 5Z"
      />
    </g>
    <g id="lunge-2">
      <path
        fill="var(--hair)"
        d="M480 630c-5 6-12 10-21 11-17 2-34 2-52 0l-31-2c-2 0-5 0-4-3 3-12 3-25 9-36 1-2 1-5 4-3l6 9c2 3 7 6 10 3 4-4 11-5 10-12-1-6 1-9 7-10 2 1 2 4 2 6 0 9 6 13 13 16 13 5 25 13 40 13 3 0 5 2 7 3ZM56 649c1 4-2 4-4 4-6-1-6 2-7 6-1 6 0 11 7 13 4 1 7 5 10 7 3 1 3 3 3 6s-2 4-5 5l-14 3H33c-16-4-23-15-25-31-1-9-5-18-7-26-3-12 2-18 14-18l14 1c2 0 2 1 2 2l-3 4c-4 4-7 8-3 13 3 5 15 10 19 8 5-2 9 0 12 3Z"
      />
      <path
        fill="var(--pants)"
        d="M370 467a173 173 0 0 0-14 29c-2 4-2 9-6 12l-3-4-9-30c-3-8-5-18-11-25v-5c4-5 7-11 14-14 4 0 8 3 12-1 3-1 5 1 7 2 6 3 11 8 19 3 2-1 6 1 7 5-3 1-4 4-5 7-4 6-8 12-9 19Z"
      />
      <path
        fill="var(--shirt)"
        d="M332 347a7 7 0 0 1-3-4 7 7 0 0 0 3 4c1-7-2-13-4-19-5-16-18-26-27-39a15 15 0 0 0-8-6c-2-1-4-3-7-2-2-6-8-8-12-10-8-4-15-8-23-9a114 114 0 0 0-23 101l9 47c1 6 2 12 0 17-4 11-10 21-12 33-2 7-6 13-4 20l13 4 40 9c13 2 23 0 31-10-1-5-4-7-7-10s-4-6-4-10v-3c-5-8-10-15-12-25a3 3 0 0 1 0-1c-1-6-7-11-7-18l-10-29c-2-4 6-13 11-14 7-1 15 1 22-2 5-3 9 2 9 6 1 6 4 12 4 18a36 36 0 0 1 5 19v3c5 4 2 10 3 16 3 1 2 3 2 5a8 8 0 0 0 6 6c4-5 7-11 14-14-1-28-7-55-9-83Zm-4-7 1 2-1-2Z"
      />
      <path
        fill="var(--pants)"
        d="m317 496-2-2-2-3-8-8c-8 10-18 12-31 10l-40-9c0 4-2 3-5 2 2-2 4-1 5-2l-13-4a42 42 0 0 0 3 23c0 5-7 10 1 15l-1 5-8 25-7 18c-2 7-6 13-6 20 9 7 17 13 29 14l24 1a72 72 0 0 1 30-7c6 0 8-3 8-8l4-47c5-14 11-27 28-27-1-7-7-10-9-16Z"
      />
      <path
        fill="var(--hair)"
        d="M319 169h-8c-16-2-31-1-47 2-13 3-19 14-20 23-1 19 5 36 10 54l7-5c6-7 1-14 0-21-1-8 1-12 10-12 3 3 6 7 6 11 1 4 3 4 6 3 5-3 10-6 10-13 0-4 2-7 6-9 5-2 6-6 4-11-1-5 1-7 6-7a48 48 0 0 1 7 1l4 3a26 26 0 0 0 6-9c2-6 0-10-7-10Z"
      />
      <path fill="var(--pants)" d="M234 484c0 4-2 3-5 2 2-2 4-1 5-2Z" />
      <path
        fill="var(--flesh)"
        d="M203 586c-2 1-3 4-3 6-2 7-6 13-9 19-2 5-6 7-11 7l-9-2c-17-4-35-6-53-3-26 5-53 9-80 7l-7 1-3 4c-4 4-7 8-3 13 3 5 15 10 19 8 5-2 9 0 12 3 2-2 5-2 8-2a102 102 0 0 1 34 4c34 9 69 7 104 10 11 1 19-4 23-14 4-8 11-15 17-23 5-7 11-14 14-23l-24-1c-12-1-20-7-29-14ZM428 449l-42-9c-3 0-4 3-5 6v7-7c-4 6-8 12-9 19l-2 2a173 173 0 0 0-14 29 301 301 0 0 0 40 2c3 0 4 1 3 5a63 63 0 0 0-4 14c-3 19-2 38-6 57-1 8-1 16-4 23l6 9c2 3 7 6 10 3 4-4 11-5 10-12-1-6 1-9 7-10-1-11 3-20 6-29l7-18 19-50c8-18-3-37-22-41Zm-50 19a2 2 0 0 0-2-2 2 2 0 0 1 2 2ZM329 233c5-3 3-7 0-10-2-3-5-7-5-11 1-8-2-16-4-24l-4-3a48 48 0 0 0-7-1c-5 0-7 2-6 7 2 5 1 9-4 11-4 2-6 5-6 9 0 7-4 10-10 13-3 1-5 1-6-3 0-4-3-8-6-11-9 0-11 4-10 12 1 7 6 14 0 21l-7 5c-2 4-2 9-3 14 8 1 15 5 23 9 4 2 10 4 12 10 3-1 5 1 7 2l1-6c1-12 5-15 17-15h4c5 0 7-2 8-7 0-7 7-12 4-20l2-2Z"
      />
      <path
        fill="var(--flesh)"
        d="M360 530c-6-6-9-13-10-22l-3-4-9-30c-3-8-5-18-11-25v-5a8 8 0 0 1-6-6c0-2 1-5-2-5-1-6 2-12-3-16v-3a36 36 0 0 0-5-19c0-6-3-12-4-18 0-4-4-9-9-6-7 3-15 1-22 2-5 1-13 10-11 14l10 29c0 7 6 12 7 18a3 3 0 0 0 0 1c2 9 7 17 12 25v3c0 4 1 7 4 10s6 5 7 9l8 9 2 3 2 1v1c2 6 8 9 9 16a29 29 0 0 1 9 19c1 8 2 15 7 21 6 6 7 13 3 19-3 5 0 7 4 8 2 4 5 0 8 0 8 0 18-13 18-22 0-12-7-20-15-27Zm-12 5a1 1 0 0 1-1 0 1 1 0 0 0 1 0Z"
      />
    </g>
    <g id="lunge-3">
      <path
        fill="var(--flesh)"
        d="m422 475-42-10c-4 1-5 4-6 6v8-8c-3 6-8 12-9 19l-2 2a174 174 0 0 0-14 29 303 303 0 0 0 39 2c4 0 5 1 4 5a63 63 0 0 0-5 15c-2 19-1 38-5 56-2 8-2 16-5 24l6 8c2 2 6 6 10 3 3-3 11-4 10-12-1-6 1-9 7-10-1-10 3-19 6-29l8-17c6-17 11-34 19-50 8-18-2-37-21-41Zm-51 18a2 2 0 0 0-2-2 2 2 0 0 1 2 2ZM249 567l2-43c-1-3-4-4-7-4l-7 1 7-1c-7-3-13-6-20-6l-2-1a175 175 0 0 0-32-9 303 303 0 0 0 5 39c1 4 0 5-4 4a63 63 0 0 0-15-1c-19 0-38 5-57 4-8 0-47 2-55 0a99 99 0 0 0-8 8c-2 3-5 8-1 10 4 3 6 11 13 8 6-2 33 3 47 3s16 0 26 2l19 4 52 10c19 5 37-8 37-28Zm-27-46a2 2 0 0 0 2-3 2 2 0 0 1-2 3Z"
      />
      <path
        fill="var(--pants)"
        d="M340 439c-8-3-16-5-23-10a5 5 0 0 1-2-2c-3 1-6-1-8-1-7 3-11 9-14 14v5c6 7 7 17 10 25l10 30c0 2 1 3 3 4-9 23-9 47 24 27 16-2 24 3 29-7l5-42c1-7 9-14 13-20l-40-20-7-3Z"
      />
      <path
        fill="var(--shirt)"
        d="M298 343a7 7 0 0 1-3-4 7 7 0 0 0 3 4c1-7-2-13-5-19-5-16-18-26-26-39a15 15 0 0 0-9-6c-1-1-3-3-6-2-2-6-8-8-13-10-7-4-14-8-23-9-7 10-13 19-19 31-10 22-9 46-4 70l9 47c1 6 2 12 0 17-3 11-9 21-12 33-1 7-5 13-3 20l13 4c14 3 26 7 40 9 12 2 23 0 31-10-1-5-5-7-7-10-3-3-5-6-4-10v-3c-5-8-10-15-12-24a3 3 0 0 1 0-2c-1-6-7-11-7-17l-10-30c-2-4 6-13 11-14 7-1 14 1 22-2 5-3 8 2 9 6l3 18a36 36 0 0 1 6 19v3c5 4 2 10 2 16h1c3 1 2 3 2 5a8 8 0 0 0 6 6c3-5 7-11 14-14-1-28-7-55-9-83Zm-4-7v2-2Z"
      />
      <path
        fill="var(--pants)"
        d="M186 502v22c26 8 54 7 75 3 30 4 80 19 31-19-1-7-7-10-9-16l-2-2-2-2-8-9c-8 10-19 12-31 10-14-2-26-6-40-9 0 4-2 3-5 2 2-2 4-1 5-2l-13-4-1 23v3Z"
      />
      <path
        fill="var(--hair)"
        d="m285 165-9 1c-15-3-31-2-46 1-13 3-20 14-20 23-1 19 5 36 10 54l7-5c6-7 1-14 0-21-1-8 0-12 10-12 3 3 5 7 6 11 0 4 3 4 6 3 5-3 9-6 10-13 0-4 2-7 6-9 5-2 5-6 4-11s1-7 6-7a49 49 0 0 1 7 1l4 3a26 26 0 0 0 6-9c2-6 0-10-7-10Z"
      />
      <path fill="var(--pants)" d="M200 480c0 4-2 3-5 2 2-2 4-1 5-2Z" />
      <path
        fill="var(--flesh)"
        d="M294 229c5-3 4-6 1-10-3-3-6-6-5-11 1-8-2-16-4-24l-4-3a49 49 0 0 0-7-1c-5 0-7 2-6 7s1 9-4 11c-4 2-6 5-6 9-1 7-5 10-10 13-3 1-6 1-6-3-1-4-3-8-6-11-10 0-11 4-10 12 1 7 6 14 0 21-2 2-4 5-7 5-3 4-3 9-4 14 9 1 16 5 23 9 5 2 11 4 13 10 3-1 5 1 6 3l2-7c1-12 5-15 17-15h4c4 0 7-2 7-7 1-7 8-12 5-20l1-2ZM326 526c-7-6-9-13-10-22-2-1-3-2-3-4l-10-30c-3-8-4-18-10-25v-5a8 8 0 0 1-6-6c0-2 1-4-3-5 0-6 3-12-2-16l-1-3a36 36 0 0 0-5-19l-3-18c-1-4-4-9-9-6-8 3-15 1-22 2-5 1-13 10-11 14l10 30c0 6 6 11 7 17a3 3 0 0 0 0 2c2 9 7 16 12 24v3c-1 4 1 7 4 10 2 3 6 5 7 10l8 8 2 3 2 2c2 6 8 9 9 16a29 29 0 0 1 9 19c1 8 2 15 7 21s7 13 3 20c-3 4 0 6 3 7 3 4 6 0 9 0 8 0 18-13 18-22 0-12-7-19-15-27Zm-12 5a1 1 0 0 1-1 0 1 1 0 0 0 1 0Z"
      />
      <path
        fill="var(--hair)"
        d="M96 577c2 5-2 5-4 4-5 0-6 2-7 7 0 6 0 11 7 13 4 1 7 4 11 6 2 1 3 4 2 6 0 3-2 5-4 5l-15 4H74l-1-1c-16-3-23-14-24-30-1-9-5-18-8-27-3-12 2-18 14-18 5 0 10 2 15 1l2 3-3 4c-5 3-7 7-4 13 4 5 15 10 19 8 5-3 9-1 12 2ZM480 651c-6 8-13 11-23 12-19 2-38 3-57 1l-35-2c-2-1-5 0-4-4 3-13 3-27 10-40 1-2 1-5 4-3l7 10c3 3 7 6 10 3 5-4 13-5 12-13-1-7 1-10 7-11 3 1 3 4 3 6 0 11 6 15 14 18 15 6 28 15 45 15 3 0 5 2 7 4Z"
      />
    </g>
  </g>
</g>
    {#if isPaused}
    <svg viewBox="-6 -5 36 36" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M10 24h-6v-24h6v24zm10 0h-6v-24h6v24zm-11-23h-4v22h4v-22zm10 0h-4v22h4v-22z"/></svg>
    {/if} 
  </svg>